import React from "react";
import { useBooleanState } from "../../core/hooks/useBooleanState";
import { useDidUpdate } from "../../core/hooks/useDidUpdate";
import { IProcedureRowType } from "../../graphql/gpl-graphQLTypes.gen";
import { IProcedureRow } from "../../typings/filterEntities";
import ProcedureRow from "../ProcedureRow/ProcedureRow";

const INDENTATION = 8 * 5; // baseUnit: 8px

export type BaseProcedureStepWithOffsprings<T> = T & {
  offsprings: Array<BaseProcedureStepWithOffsprings<T>>;
  parent: BaseProcedureStepWithOffsprings<T> | null;
};
export type StepWithOffspring = BaseProcedureStepWithOffsprings<IProcedureRow>;

interface IProps {
  step: StepWithOffspring;
  depth: number;
  offspringsVisibleDefault: boolean;
}

export default function ProcedureRowContainer({ step, depth, offspringsVisibleDefault }: IProps) {
  const [offspringsVisible, showOffsprings, hideOffsprings, toggleOffsprings] =
    useBooleanState(offspringsVisibleDefault);

  useDidUpdate(() => {
    // When we click on button in parent Component to Expand/Collapse All
    if (offspringsVisibleDefault) {
      showOffsprings();
    } else {
      hideOffsprings();
    }
  }, [offspringsVisibleDefault]);

  let offspringsFieldsCount = 0;
  const offsprings = step.offsprings?.map((stepChild) => {
    if (stepChild.type !== IProcedureRowType.Heading) {
      offspringsFieldsCount++;
    }
    const paddingLeft =
      step.type === IProcedureRowType.Section || stepChild.type === IProcedureRowType.Condition
        ? 0
        : INDENTATION;
    return (
      <div key={`step-${stepChild.id}`} style={{ paddingLeft }}>
        <ProcedureRowContainer
          step={stepChild}
          depth={depth + 1}
          offspringsVisibleDefault={offspringsVisibleDefault}
        />
      </div>
    );
  });

  const firstLevelConditionChild = step?.offsprings?.[0]?.type === IProcedureRowType.Condition;
  return (
    <React.Fragment key={`step-${step.id}`}>
      <ProcedureRow
        row={step}
        key={step.id}
        offspringsVisible={offspringsVisible}
        offspringsFieldsCount={offspringsFieldsCount}
        onToggleOffsprings={offsprings.length ? toggleOffsprings : undefined}
      />
      <div style={{ display: offspringsVisible || firstLevelConditionChild ? "block" : "none" }}>
        {offsprings}
      </div>
    </React.Fragment>
  );
}
